import { render, staticRenderFns } from "./ForumResponseEditorMentionSuggestion.vue?vue&type=template&id=5cddc37e&scoped=true"
import script from "./ForumResponseEditorMentionSuggestion.vue?vue&type=script&lang=js"
export * from "./ForumResponseEditorMentionSuggestion.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseEditorMentionSuggestion.vue?vue&type=style&index=0&id=5cddc37e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cddc37e",
  null
  
)

export default component.exports